import { render, staticRenderFns } from "./vw-flat-rate-modal.vue?vue&type=template&id=f1a544fa&scoped=true&"
import script from "./vw-flat-rate-modal.vue?vue&type=script&lang=js&"
export * from "./vw-flat-rate-modal.vue?vue&type=script&lang=js&"
import style0 from "./vw-flat-rate-modal.vue?vue&type=style&index=0&id=f1a544fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a544fa",
  null
  
)

export default component.exports